import { createStyles, Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { colorSectionHeadingOnLight } from '../../../../shared/style-settings'

export const useMainPageSectionHeaderStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'space-between',
      gap: theme.spacing(3),
      marginBottom: theme.spacing(5),
      flexWrap: 'wrap',
    },
    textColumn: {
      flex: '1 1 auto',
      minWidth: 0,
      maxWidth: 720,
    },
    title: {
      margin: 0,
      marginBottom: theme.spacing(1.25),
      fontWeight: 700,
      fontSize: 'clamp(1.5rem, 2vw, 2.125rem)',
      color: colorSectionHeadingOnLight,
      letterSpacing: '-0.02em',
    },
    subtitle: {
      margin: 0,
      fontSize: 'clamp(0.875rem, 1.35vw, 1.0625rem)',
      lineHeight: 1.65,
      color: theme.palette.text.secondary,
      fontWeight: 500,
    },
    actions: {
      flexShrink: 0,
      display: 'flex',
      alignItems: 'center',
      alignSelf: 'flex-end',
    },
  })
)
